import { render, staticRenderFns } from "./ProductListSlotLeft.vue?vue&type=template&id=1aed692a&scoped=true&"
import script from "./ProductListSlotLeft.vue?vue&type=script&lang=ts&"
export * from "./ProductListSlotLeft.vue?vue&type=script&lang=ts&"
import style0 from "./ProductListSlotLeft.vue?vue&type=style&index=0&id=1aed692a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed692a",
  null
  
)

export default component.exports